import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useRef } from "react";
import { useFocusList } from "../../utilities/focus-list/useFocusList";
import { useCombineRefs } from "../../hooks/useCombineRefs";
import { AppMenuListContext } from "./AppMenuListContext";
import * as Styled from "./AppMenuList.styled";
export const AppMenuList = forwardRef((props, ref) => {
    const { children, hasIcons, isSubMenu, ...otherProps } = props;
    const listRef = useRef(null);
    const { focusPrev, focusNext } = useFocusList({ listRef });
    const { hasParentMenu } = React.useContext(AppMenuListContext);
    const hasFocusList = isSubMenu || hasParentMenu;
    const handleKeyDown = hasFocusList
        ? () => { }
        : (event) => {
            switch (event.key) {
                case "ArrowDown":
                    event.preventDefault();
                    focusNext();
                    break;
                case "ArrowUp":
                    event.preventDefault();
                    focusPrev();
                    break;
                default:
                    break;
            }
        };
    return (_jsx(Styled.AppMenuList, { "data-testid": "AppMenuList", ref: useCombineRefs(listRef, ref), hasIcons: hasIcons, onKeyDown: handleKeyDown, ...otherProps, children: children }));
});
AppMenuList.defaultProps = {
    isSubMenu: false
};
AppMenuList.displayName = "AppMenuList";
